import { IconButton, Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const useStyles = makeStyles(() => ({
  selectable: {
    userSelect: 'text'
  },
  subheading: {
    fontSize: '14px !important',
    display: 'block',
    width: '70%',
    textAlign: 'end'
  },
  subLable: {
    fontWeight: '600 !important',
    fontSize: '14px !important',
    color: '#575858'
  }
}));

const CopyableField = ({ label, value }) => {
  const classes = useStyles();
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    const jsonString = JSON.stringify(value);
    e.stopPropagation();
    if (value) {
      navigator.clipboard.writeText(jsonString);
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    }
  };

  return (
    <>
      <Typography className={`${classes.subheading} ${classes.selectable}`}>
        <span className={classes.subLable}>Copy Raw Prompt</span>
        <Tooltip title={copied ? 'Copied!' : `Copy ${label}`}>
          <IconButton size="small" onClick={handleCopy}>
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Typography>
    </>
  );
};

CopyableField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

export default CopyableField;
